'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class responsibleModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'responsible':
				if(typeof(this.email) !== 'undefined'){
					return this.name + ' ' + this.lastname + ', ' + this.email;
				}
				else{
					return this.responsible_email;
				}
				return null;
			case 'namelastname':
				if(typeof(this.name) !== 'undefined' || typeof(this.lastname) !== 'undefined'){
					return this.name + ' ' + this.lastname;
				}
				return null;
			case 'activeemail':
				if(typeof(this.email) !== 'undefined'){
					return '<a href="mailto:'+this.email+'">'+this.email+'</a>';
				}
				return null;
			case 'term':
				if(typeof(this.term) === 'undefined' || this.term < 1){
					return null;
				}
				return this.s('$filter')('u2date')(this.term, 'dd/MM/y');
			
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
	
	afterSetup(data){
		this.makeCetField('term', true);
	}
}
